module.exports = "query getRedirects{entries(type:\"redirects\"){...on redirects_redirects_Entry{from:redirectFrom to:redirectTo}}}"